export default "__VITE_ASSET__6IGgyf27__"